import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import NestedFirstRow from './NestedFirstRow.es.js';
import NonNestedRow from './NonNestedRow.es.js';
import PageNavigationContext from './PageNavigationContext.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { Link } from '../Link/Link.es.js';

const list = "_list_8dci6_1";
const title = "_title_8dci6_8";
const expandAllButton = "_expand-all-button_8dci6_13";
const styles = {
	list: list,
	title: title,
	expandAllButton: expandAllButton
};

const getInitialExpansionStateLookupTable = (items) => {
  const lookupTable = {};
  for (const item of items) {
    lookupTable[item.id] = item.initiallyExpanded || false;
  }
  return lookupTable;
};
function PageNavigation({ initiallySelected, items, nested, onSelect, showExpandAllButton = false, title }) {
  const [id, setId] = useState(initiallySelected || "");
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const [expansionStateLookupTable, setExpansionStateLookupTable] = useState(getInitialExpansionStateLookupTable(items));
  const isExpanded = (rowId) => {
    return expansionStateLookupTable[rowId] || false;
  };
  const toggleExpand = (rowId) => {
    setExpansionStateLookupTable((lookupTable) => {
      return Object.assign(Object.assign({}, lookupTable), { [rowId]: !lookupTable[rowId] });
    });
  };
  const expandAll = () => {
    setExpansionStateLookupTable((lookupTable) => {
      const newLookupTable = Object.assign({}, lookupTable);
      for (const item in newLookupTable) {
        newLookupTable[item] = !isAllExpanded;
      }
      setIsAllExpanded((allExpanded) => !allExpanded);
      return newLookupTable;
    });
  };
  if (!items) {
    return null;
  }
  const showCount = items.some((item) => (item.count || 0) > 0);
  return jsxs(PageNavigationContext.Provider, { value: { id, setId, toggleExpand }, children: [nested && showExpandAllButton && jsx("div", { onClick: expandAll, onKeyPress: expandAll, "data-testid": "pagenavigation-expandall-button", role: "button", tabIndex: 0, className: styles.expandAllButton, "data-zds": true, children: jsx(Link, { children: isAllExpanded ? "Collapse all" : "Expand all" }) }), title && jsx("div", { className: styles.title, "data-zds": true, children: jsx(Text, { tag: "p", type: "ParagraphHeader3", children: title }) }), jsx("ul", { className: styles.list, "data-zds": true, children: nested ? items.map((item) => jsx(NestedFirstRow, { item, isExpanded: isExpanded(item.id), onSelect }, item.id)) : items.map((item) => jsx(NonNestedRow, { item, onSelect, showCount }, item.id)) })] });
}

export { PageNavigation };
//# sourceMappingURL=PageNavigation.es.js.map
